<template>
    <div class="iframediv">
        <iframe class="iframeclass" :src="url" width="100%" height="100%"
         scrolling="no" frameborder="0" border="0" marginwidth="0"
          marginheight="0" allowtransparency="yes"  type="application/*"
         ></iframe>
         <!-- <embed :src="url" type="application/pdf"> -->
         <!-- <a :href="url"></a> -->
    </div>
</template>
<script>
export default {
    props:{
        url: {
            type: String,
            default:()=>{
                return ''
            }
        }
    },
    data(){
        return{
        //   url: this.$route.query.url
        }
    }
}
</script>
<style lang="less" scoped>
.iframediv{
   display: none;
}
.iframeclass{
   display: none;
}
</style>